/* eslint-disable
    one-var
*/
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {groupBy, naturalSort} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

// @ts-expect-error
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';
import {FileAnalyticsParams} from 'notebook/util/analytics/FileAnalyticsUtils';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import MenuOptionWithFloatingSubmenu from 'ui-library/menus/MenuOptionWithFloatingSubmenu';
import {defaultRenderOptionContent, getOptionRefForIndex} from 'ui-library/menus/MenuUtil';
import Option from 'ui-library/menus/Option';
import OptionContainer from 'ui-library/menus/OptionContainer';
import Section from 'ui-library/menus/Section';
import {ctrl} from 'util/Keyboard';
import {capwords} from 'util/NameUtil';
import {BasicEvent, ElementMouseEvent} from 'util/Types';

import {FormatData} from '../formatted-text/FormattersConstants';

function _stopPropagationForMultiSelect(e: BasicEvent): void {
  // Table editables have multi select mixin, which listens for window mouse down.
  e.stopPropagation();
}

interface BaseFormatOption<TIcon> {
  enabled: boolean;
  visible: boolean;
  submenu?: JSX.Element;
  dataTestAttrs?: DataTestAttrs;
  text?: string | JSX.Element;
  icon?: TIcon;
  active?: boolean;
}

export interface ToolbarFormatOption extends BaseFormatOption<BenchlingIconName> {
  icon?: BenchlingIconName;
  moreKey?: string;
  format: string;
  tooltip?: Array<string>;
}

export interface ToolbarFormatOptionWithDropdown extends BaseFormatOption<BenchlingIconName | JSX.Element> {
  dropdown?: Array<Array<ToolbarFormatOption>>;
  icon?: BenchlingIconName | JSX.Element;
  moreKey?: string;
  format?: string;
  tooltip?: Array<string>;
}

export interface ToolbarInsertOption extends BaseFormatOption<BenchlingIconName> {
  key: string;
  text: string;
  onClick?: ((e: ElementMouseEvent) => void) | null;
}

interface FormatButtonProps {
  active: boolean;
  clickHandler?: (format?: string, data?: FormatData) => void;
  enabled: boolean;
  format?: string;
  mouseOutHandler?: (format?: string) => void;
  mouseOverHandler?: (format?: string) => void;
  icon?: BenchlingIconName | JSX.Element | undefined;
  text?: React.ReactNode;
  tooltip: string | null;
  visible: boolean;
}

class FormatButton extends React.PureComponent<FormatButtonProps> {
  clickHandler = (): void => {
    if (typeof this.props.clickHandler === 'function') {
      this.props.clickHandler(this.props.format);
    }
  };

  mouseOverHandler = (): void => {
    if (typeof this.props.mouseOverHandler === 'function') {
      this.props.mouseOverHandler(this.props.format);
    }
  };

  mouseOutHandler = (): void => {
    if (typeof this.props.mouseOutHandler === 'function') {
      this.props.mouseOutHandler(this.props.format);
    }
  };

  mouseDownHandler = (e: BasicEvent): void => {
    e.preventDefault();
  }; // We don't want these buttons to ever get focus.

  override render(): JSX.Element {
    return (
      <Tooltip text={this.props.tooltip} disableContentSelection={true}>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          className={classNames({
            hidden: !this.props.visible,
            'is-active': this.props.active,
          })}
          disabled={!this.props.enabled}
          icon={this.props.icon}
          onClick={this.clickHandler}
          onMouseDown={this.mouseDownHandler}
          onMouseOut={this.mouseOutHandler}
          onMouseOver={this.mouseOverHandler}
          size={ButtonSize.MINI}
          text={this.props.text}
        />
      </Tooltip>
    );
  }
}

interface FormationOptionProps {
  format?: string;
  key?: string;
  text: React.ReactNode;
  icon?: BenchlingIconName | JSX.Element | undefined;
  active: boolean;
  enabled: boolean;
  visible: boolean;
  clickHandler?: (format?: string, arg2?: undefined) => void;
  mouseOverHandler?: (format?: string) => void;
  mouseOutHandler?: (format?: string) => void;
  submenu?: React.ReactNode;
  dataTestAttrs?: DataTestAttrs;
}

class FormatOption extends React.PureComponent<FormationOptionProps> {
  clickHandler = (): void => {
    if (typeof this.props.clickHandler === 'function') {
      this.props.clickHandler(this.props.format, undefined);
    }
  };

  mouseOverHandler = (): void => {
    if (typeof this.props.mouseOverHandler === 'function') {
      this.props.mouseOverHandler(this.props.format);
    }
  };

  mouseOutHandler = (): void => {
    if (typeof this.props.mouseOutHandler === 'function') {
      this.props.mouseOutHandler(this.props.format);
    }
  };

  mouseDownHandler = (e: BasicEvent): void => {
    e.preventDefault(); // We don't want these buttons to ever get focus.
    _stopPropagationForMultiSelect(e);
  };

  override render(): JSX.Element {
    return (
      <li
        // @ts-expect-error - disabled is not a valid prop for li, but leaving because I'll replace this
        disabled={!this.props.enabled}
        className={classNames({
          disabled: !this.props.enabled,
          hidden: !this.props.visible,
          active: this.props.active,
          'dropdown-submenu': this.props.submenu != null,
        })}
        onMouseEnter={this.props.enabled ? this.mouseOverHandler : undefined}
        onMouseLeave={this.props.enabled ? this.mouseOutHandler : undefined}
        {...getTestProps(this.props.dataTestAttrs)}
      >
        <a
          onClick={() => {
            if (this.props.enabled) {
              this.clickHandler();
            }
          }}
          onMouseDown={this.mouseDownHandler}
        >
          {this.props.icon && typeof this.props.icon === 'string' ? (
            <BenchlingIcon className={css(styles.toolbarOptionIcon)} icon={this.props.icon} />
          ) : (
            this.props.icon
          )}
          <span className={css(styles.toolbarOptionText)}>{this.props.text}</span>
        </a>
        {this.props.enabled ? this.props.submenu : null}
      </li>
    );
  }
}

interface StaticFormatToolbarProps {
  formatHandler: (format: string, data: FormatData | undefined) => void;
  insertHandler: (format: string, arg2: undefined, fileAnalyticsParams?: FileAnalyticsParams) => void;
  insertMouseOverHandler?: () => void;
  insertMouseOutHandler?: () => void;
  mouseOverHandler: (format?: string) => void;
  mouseOutHandler: (format?: string) => void;
  groups: Array<Array<ToolbarFormatOptionWithDropdown>>;
  inserts: Array<ToolbarInsertOption>;
  printOptions: Array<{
    type: string;
    enabled: boolean;
  }>;
  undoHandler?: (selection: {selection: BenchlingSelection}) => void;
  redoHandler?: (selection: {selection: BenchlingSelection}) => void;
  printHandler?: (type: string) => void;
  isLocked?: boolean;
}

const TooltipOptions = {
  bold: ['Bold', 'B'],
  italic: ['Italic', 'I'],
  monospace: ['Code', 'Shift + K', 'Select text to toggle first.'],
  underline: ['Underline', 'U'],
  strikethrough: ['Strikethrough', 'Shift + X'],
  subscript: ['Subscript', 'Shift + .'],
  superscript: ['Superscript', '.'],
  color: ['Color'],
  link: ['Hyperlink', 'K'],
  attach: ['Attach Item'],
  table: ['Insert Table'],
  text: ['Insert Text'],
  left: ['Align Left'],
  center: ['Align Center'],
  important: ['Toggle Important'],
  right: ['Align Right'],
  HEADER: ['Header'],
  STEP: ['Step'],
  DESC: ['Description'],
  AGGREGATE_TIME: ['Aggregate Time'],
  CRITICAL: ['Critical Point'],
  PAUSE: ['Pause Point'],
  bullet: ['Bullet'],
  number: ['Number'],
  'checkbox-unchecked': ['Checkbox'],
  print: ['Print'],
  delete: ['Remove Item'],
  selector: ['View Selectors'],
  performance: ['View Notebook Performance'],
};

class StaticFormatToolbar extends React.Component<StaticFormatToolbarProps> {
  static __FormatOption: typeof FormatOption;

  static getPartition(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editor: any,
    {editorKey, index, subIndex}: {editorKey: string; index: number; subIndex: number}
  ): boolean | null {
    const target = $(editor)
      .find(`[data-editor='${editorKey}']`)
      // We need to include $editor in the data-editor search.
      .addBack(`[data-editor='${editorKey}']`)
      .find(`div[data-index='${index}']`)
      .filter(function () {
        // @ts-expect-error
        return $(this).data('subindex') === subIndex;
      })[0];
    if (target == null) {
      return null;
    }
    return selutil.partitionSelection({target});
  }

  scrollAreaRef = React.createRef<Menu>();
  private optionRefs: {[ref: string]: HTMLLIElement | null} = {};

  static defaultProps = {
    groups: [],
    inserts: [],
    printOptions: [],
  };

  getBtnTitle = (option: ToolbarFormatOption | ToolbarFormatOptionWithDropdown): string | null => {
    const {format, tooltip, enabled} = option;
    // @ts-expect-error
    const [title, key, disabledReason] = Array.from(tooltip || TooltipOptions[format]);
    const tooltipTitle = title + (key != null ? ` (${ctrl} + ${key})` : '');
    if (enabled || !disabledReason) {
      return tooltipTitle === '' ? null : tooltipTitle;
    } else {
      return `${tooltipTitle}\n${disabledReason}`;
    }
  };

  renderDropdown = (index: number, option: ToolbarFormatOptionWithDropdown): JSX.Element | null => {
    if (!option.visible) {
      return null;
    }
    const enabled =
      (option.enabled &&
        option.dropdown &&
        option.dropdown.some((section) => section.some(({enabled}) => enabled))) ??
      false;
    return (
      <div className="buttonGroup" key={index}>
        <Dropdown
          allowMenuToCloseDropdown={true}
          noBackdrop={true}
          closeOnOutsideClick={true}
          closeOnInsideClick={true}
          tooltip={option.tooltip && this.getBtnTitle(option)}
          menu={
            <Menu width={MenuWidth.SMALL} height={MenuHeight.SMALL} scrollable={true}>
              {option.dropdown &&
                option.dropdown.map((section, sectionIdx) => (
                  <Section key={sectionIdx}>
                    {section.map((option, optionIdx) => {
                      if (!option.visible) {
                        return null;
                      } else if (option.submenu != null) {
                        return (
                          <OptionContainer
                            key={optionIdx}
                            isDisabled={option.enabled === false}
                            ref={(node) => {
                              if (node != null) {
                                this.optionRefs[getOptionRefForIndex(index)] = node.getRef();
                              }
                            }}
                            onSelect={() => {
                              this.props.formatHandler(option.format, undefined);
                            }}
                          >
                            <MenuOptionWithFloatingSubmenu
                              menuOptionContainer={this.optionRefs[getOptionRefForIndex(index)]}
                              menuOptionIndex={index}
                              optionData={{
                                icon: option.icon,
                                name: option.text || '',
                                disabled: option.enabled === false,
                                dataTestAttrs: option.dataTestAttrs,
                                submenu: [],
                              }}
                              submenuProps={{width: MenuWidth.FIT_CONTENT, height: MenuHeight.SMALL}}
                              renderOptionContentFn={defaultRenderOptionContent}
                            >
                              {[option.submenu]}
                            </MenuOptionWithFloatingSubmenu>
                          </OptionContainer>
                        );
                      } else {
                        return (
                          <Option
                            key={optionIdx}
                            icon={typeof option.icon === 'string' ? option.icon : undefined}
                            isDisabled={option.enabled === false}
                            onHover={() => {
                              if (typeof this.props.mouseOverHandler === 'function') {
                                this.props.mouseOverHandler(option.format);
                              }
                            }}
                            onMouseOut={() => {
                              if (typeof this.props.mouseOutHandler === 'function') {
                                this.props.mouseOutHandler(option.format);
                              }
                            }}
                            onSelect={() => {
                              this.props.formatHandler(option.format, undefined);
                            }}
                            dataTestAttrs={option.dataTestAttrs}
                          >
                            {option.icon && typeof option.icon !== 'string' && option.icon}
                            {option.text}
                          </Option>
                        );
                      }
                    })}
                  </Section>
                ))}
            </Menu>
          }
        >
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            disabled={!enabled}
            icon={option.icon}
            isDropdown={true}
            size={ButtonSize.MINI}
            text={option.text}
            dataTestAttrs={option.dataTestAttrs}
          />
        </Dropdown>
      </div>
    );
  };

  renderSingleComponentDropdown = (index: number, option: ToolbarFormatOptionWithDropdown): JSX.Element => (
    <div className="dropdown buttonGroup" key={index}>
      <Dropdown
        allowMenuToCloseDropdown={true}
        noBackdrop={true}
        closeOnOutsideClick={true}
        closeOnInsideClick={false}
        tooltip={this.getBtnTitle(option)}
        menu={
          <Menu width={MenuWidth.FIT_CONTENT} height={MenuHeight.SMALL}>
            <OptionContainer key="table" isHovered={false} disableEventPropagation={true}>
              {option.submenu}
            </OptionContainer>
          </Menu>
        }
      >
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          className="mediocre-toolbar-dropdownBtn"
          disabled={!option.enabled}
          icon={option.icon}
          isDropdown={true}
          size={ButtonSize.MINI}
          text={option.text}
          dataTestAttrs={option.dataTestAttrs}
        />
      </Dropdown>
    </div>
  );

  renderBtnGroup = (
    options: Array<ToolbarFormatOptionWithDropdown>,
    i: number,
    withLeftMargin: boolean
  ): JSX.Element | null => {
    let visible, moreKey;
    if (
      !_.any(
        (() => {
          const result = [];
          for ({visible, moreKey} of Array.from(options)) {
            result.push(visible && !moreKey);
          }
          return result;
        })()
      )
    ) {
      return null;
    }
    return (
      <div
        className={classNames('u-display-inline-block', {
          buttonGroup: options.length > 1,
          'u-tiny-spacing-left': withLeftMargin,
        })}
        key={i}
      >
        {(() => {
          const result1 = [];
          for (let index = 0; index < options.length; index++) {
            const option = options[index];
            if (option.moreKey) {
              continue;
            }
            if (option.dropdown != null) {
              result1.push(this.renderDropdown(index, option));
            } else if (option.submenu != null) {
              result1.push(this.renderSingleComponentDropdown(index, option));
            } else {
              result1.push(
                <FormatButton
                  active={option.active ?? false}
                  clickHandler={this.props.formatHandler}
                  enabled={option.enabled}
                  format={option.format}
                  icon={option.icon}
                  key={option.format}
                  mouseOutHandler={this.props.mouseOutHandler}
                  mouseOverHandler={this.props.mouseOverHandler}
                  text={option.text}
                  tooltip={this.getBtnTitle(option)}
                  visible={option.visible}
                />
              );
            }
          }
          return result1;
        })()}
      </div>
    );
  };

  renderInsert = (): JSX.Element | null => {
    let visible;
    if (
      !_.any(
        (() => {
          const result = [];
          for ({visible} of Array.from(this.props.inserts)) {
            result.push(visible);
          }
          return result;
        })()
      )
    ) {
      return null;
    }
    return (
      <div className="buttonGroup u-tiny-spacing-left">
        <Dropdown
          allowMenuToCloseDropdown={true}
          noBackdrop={true}
          closeOnOutsideClick={true}
          closeOnInsideClick={true}
          menu={
            <Menu width={MenuWidth.SMALL} height={MenuHeight.SMALL}>
              {this.props.inserts &&
                this.props.inserts.map((option, optionIdx) => {
                  if (option.visible === false) {
                    return null;
                  }
                  return (
                    <Option
                      key={optionIdx}
                      icon={option.icon}
                      isDisabled={option.enabled === false}
                      onHover={this.props.insertMouseOverHandler ?? this.props.mouseOverHandler}
                      onMouseOut={this.props.insertMouseOutHandler ?? this.props.mouseOutHandler}
                      onSelect={() => {
                        this.props.insertHandler(option.key, undefined);
                      }}
                      _submenu={
                        option.submenu ? (
                          <Menu width={MenuWidth.FIT_CONTENT} height={MenuHeight.SMALL}>
                            {[option.submenu]}
                          </Menu>
                        ) : null
                      }
                    >
                      {option.text}
                    </Option>
                  );
                })}
            </Menu>
          }
        >
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            isDropdown={true}
            size={ButtonSize.MINI}
            text="Insert"
          />
        </Dropdown>
      </div>
    );
  };

  renderPrint = (): JSX.Element | null => {
    if (this.props.printOptions.length === 0) {
      return null;
    }

    if (this.props.printOptions.length === 1) {
      return (
        <div
          className="buttonGroup"
          key="btn-group-print"
          {...getTestProps({component: 'StaticFormatToolbar', element: 'printButton'})}
        >
          <FormatButton
            active={false}
            clickHandler={this.props.printHandler}
            enabled={this.props.printOptions[0].enabled}
            format={this.props.printOptions[0].type}
            icon="format-print"
            tooltip="Print"
            visible={true}
          />
        </div>
      );
    }

    return (
      <div className="buttonGroup" key="btn-group-print">
        <Dropdown
          allowMenuToCloseDropdown={true}
          noBackdrop={true}
          closeOnOutsideClick={true}
          closeOnInsideClick={true}
          menu={
            <Menu width={MenuWidth.SMALL} height={MenuHeight.SMALL}>
              {this.props.printOptions &&
                this.props.printOptions.map((option, optionIdx) => (
                  <Option
                    key={optionIdx}
                    isDisabled={option.enabled === false}
                    onSelect={() => {
                      if (option.enabled && this.props.printHandler) {
                        this.props.printHandler.call(null, option.type);
                      }
                    }}
                    dataTestAttrs={{
                      component: 'StaticFormatToolbar',
                      element: 'printOption',
                      key: option.type,
                    }}
                  >
                    {`Print ${capwords(option.type.toLowerCase())}`}
                  </Option>
                ))}
            </Menu>
          }
        >
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            icon="format-print"
            isDropdown={true}
            size={ButtonSize.MINI}
            dataTestAttrs={{component: 'StaticFormatToolbar', element: 'printDropdownButton'}}
          />
        </Dropdown>
      </div>
    );
  };

  renderMore = (): JSX.Element | null => {
    const flattenedOptions = this.props.groups.flatMap((group) => group);
    const moreOptions = flattenedOptions.filter(
      (x: ToolbarFormatOptionWithDropdown): x is ToolbarFormatOptionWithDropdown & {moreKey: string} =>
        Boolean(x.moreKey) && x.visible
    );
    if (moreOptions.length === 0) {
      return null;
    }

    const groups = groupBy(moreOptions, (option) => option.moreKey);
    const keys = naturalSort(Object.keys(groups));

    return (
      <div className="buttonGroup u-tiny-spacing-left" key="btn-group-more">
        <Dropdown
          allowMenuToCloseDropdown={true}
          noBackdrop={true}
          closeOnOutsideClick={true}
          closeOnInsideClick={true}
          menu={
            <Menu width={MenuWidth.SMALL} height={MenuHeight.SMALL}>
              {Array.from(keys).map((groupKey, sectionIdx) => (
                <Section key={sectionIdx}>
                  {groups[groupKey].map((option, optionIdx) => {
                    if (!option.visible) {
                      return null;
                    }
                    return (
                      <Option
                        key={optionIdx}
                        isDisabled={option.enabled === false}
                        isSelected={option.active}
                        onHover={() => {
                          if (typeof this.props.mouseOverHandler === 'function') {
                            this.props.mouseOverHandler(option.format);
                          }
                        }}
                        onMouseOut={() => {
                          if (typeof this.props.mouseOutHandler === 'function') {
                            this.props.mouseOutHandler(option.format);
                          }
                        }}
                        onSelect={() => {
                          this.props.formatHandler(option.format!, undefined);
                        }}
                        dataTestAttrs={option.dataTestAttrs}
                      >
                        {this.getBtnTitle(option)}
                      </Option>
                    );
                  })}
                </Section>
              ))}
            </Menu>
          }
        >
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            isDropdown={true}
            size={ButtonSize.MINI}
            text="More"
          />
        </Dropdown>
      </div>
    );
  };

  renderUndoRedo = (hasContentBefore: boolean): JSX.Element | null => {
    const {isLocked, redoHandler, undoHandler} = this.props;
    if (isLocked || !redoHandler || !undoHandler) {
      return null;
    }

    const selectionData = selutil.getSelectionIndices();
    return (
      <div
        className={classNames({
          buttonGroup: true,
          'u-tiny-spacing-left': hasContentBefore,
        })}
        key="btn-group-undoRedo"
      >
        <FormatButton
          active={false}
          clickHandler={() => {
            if (this.props.undoHandler) {
              this.props.undoHandler({selection: selectionData});
            }
          }}
          enabled={true}
          format="undo"
          icon="rotate-left"
          tooltip={`Undo (${ctrl} + Z)`}
          visible={true}
        />
        <FormatButton
          active={false}
          clickHandler={() => {
            if (this.props.redoHandler) {
              this.props.redoHandler({selection: selectionData});
            }
          }}
          enabled={true}
          format="redo"
          icon="rotate-right"
          tooltip={`Redo (${ctrl} + Shift + Z)`}
          visible={true}
        />
      </div>
    );
  };

  override render(): JSX.Element {
    const maybePrintButton = this.renderPrint();
    const maybeUndoRedoButton = this.renderUndoRedo(Boolean(maybePrintButton));
    const maybeInsertDropdown = this.renderInsert();
    const hasContentBeforeFormattingGroups = Boolean(
      maybePrintButton || maybeUndoRedoButton || maybeInsertDropdown
    );
    return (
      <EditorPropertiesContext.Consumer>
        {(editorPropertiesContext) => (
          <div
            className={
              editorPropertiesContext.autoHeightToolbar
                ? classNames('mediocre-toolbar', css(styles.toolbarAutoHeight))
                : 'mediocre-toolbar'
            }
            {...getTestProps({component: 'StaticFormatToolbar', element: 'root'})}
          >
            {maybePrintButton}
            {maybeUndoRedoButton}
            {maybeInsertDropdown}
            {Array.from(this.props.groups).map((group, i) =>
              this.renderBtnGroup(group, i, hasContentBeforeFormattingGroups || i > 0)
            )}
            {this.renderMore()}
          </div>
        )}
      </EditorPropertiesContext.Consumer>
    );
  }
}

StaticFormatToolbar.__FormatOption = FormatOption;
export default StaticFormatToolbar;

const styles = StyleSheet.create({
  toolbarOptionIcon: {
    marginRight: 8,
    verticalAlign: 'middle',
  },
  toolbarOptionText: {
    verticalAlign: 'middle',
  },
  toolbarAutoHeight: {
    height: 'auto',
    lineHeight: 1,
    // Use a compact, unitless line-height so the toolbar height matches the
    // height of the editor buttons while still scaling with font size and zoom.
  },
});
